import React from "react";

import { CreateKintoneExportSettingInput } from "@graffer-inc/smart-apply";
import { kintoneAppUrlRegex } from "../../../../../application/domain/kintone-export";

export type KintoneUrlParam = Pick<
  CreateKintoneExportSettingInput,
  "kintoneAppId" | "kintoneSubdomain"
>;

export const useUrlInputProps = (arg: {
  param: KintoneUrlParam;
  onChange: (param: KintoneUrlParam) => void;
}) => {
  const { kintoneAppId, kintoneSubdomain } = arg.param;

  const [value, setValue] = React.useState<string>(
    !!kintoneAppId && !!kintoneSubdomain
      ? `https://${arg.param.kintoneSubdomain}.cybozu.com/k/${arg.param.kintoneAppId}/`
      : "",
  );
  const [errorMessages, setErrorMessages] = React.useState<string | undefined>(
    undefined,
  );
  const [touched, setTouched] = React.useState(false);

  React.useEffect(() => {
    setValue(
      !!kintoneAppId && !!kintoneSubdomain
        ? `https://${arg.param.kintoneSubdomain}.cybozu.com/k/${arg.param.kintoneAppId}/`
        : "",
    );
  }, [kintoneAppId, kintoneSubdomain, setValue]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTouched(true);
    setValue(e.target.value);

    if (!e.target.value) {
      arg.onChange({ kintoneSubdomain: "", kintoneAppId: "" });
      return;
    }

    const isValid = kintoneAppUrlRegex.test(e.target.value);
    if (isValid) {
      const subdomain = e.target.value.split(".")[0].split("//")[1];
      const appId = e.target.value.split("/")[4];
      arg.onChange({ kintoneSubdomain: subdomain, kintoneAppId: appId });
      setErrorMessages(undefined);
      return;
    }
  };

  const onBlur = () => {
    setTouched(true);
  };

  React.useEffect(() => {
    if (!touched) {
      return;
    }
    const isValid = kintoneAppUrlRegex.test(value);
    if (!isValid) {
      setErrorMessages(
        "例と同じフォーマットで kintone アプリ URL を入力してください。",
      );
    }
  }, [touched, value, setErrorMessages]);

  return {
    value,
    onChange,
    errorMessages,
    onBlur,
  };
};
